import {
  LocalizeConfig,
  LocalizeDefaultConfig,
  LocalizeLanguages,
} from "smarthub-common";
import { IProps } from "./props";

const genericText = {
  chatHeadTitle: "Hello, I'm ELLIS",
  chatHeadTitleLabel: "Hello, I'm ELLIS",
  chatHeadSubTitle: "I'm here to answer your questions.",
  chatHeadSubTitleLabel: "I'm here to answer your questions.",
};

const textMapping = {
  lewesandeastbourne: genericText,
};

export const localize = ({ id }: IProps): LocalizeConfig => ({
  defaultLanguage: LocalizeLanguages.en,
  [LocalizeLanguages.en]: {
    ...LocalizeDefaultConfig.en,
    ...textMapping[id],
  },
});
